import { render, staticRenderFns } from "./LiveRoster.vue?vue&type=template&id=2de58c52&scoped=true"
import script from "./LiveRoster.vue?vue&type=script&lang=js"
export * from "./LiveRoster.vue?vue&type=script&lang=js"
import style0 from "./LiveRoster.vue?vue&type=style&index=0&id=2de58c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de58c52",
  null
  
)

export default component.exports